export const LIST_IDENTITY_TYPE_SUMMARY_REQUEST = 'LIST_IDENTITY_TYPE_SUMMARY_REQUEST'
export const LIST_IDENTITY_TYPE_SUMMARY_SUCCESS = 'LIST_IDENTITY_TYPE_SUMMARY_SUCCESS'
export const LIST_IDENTITY_TYPE_SUMMARY_FAIL = 'LIST_IDENTITY_TYPE_SUMMARY_FAIL'
export const LIST_IDENTITY_TYPE_SUMMARY_RESET = 'LIST_IDENTITY_TYPE_SUMMARY_RESET'

export const LIST_IDENTITY_TYPE_REQUEST = 'LIST_IDENTITY_TYPE_REQUEST'
export const LIST_IDENTITY_TYPE_SUCCESS = 'LIST_IDENTITY_TYPE_SUCCESS'
export const LIST_IDENTITY_TYPE_FAIL = 'LIST_IDENTITY_TYPE_FAIL'
export const LIST_IDENTITY_TYPE_RESET = 'LIST_IDENTITY_TYPE_RESET'

export const CREATE_IDENTITY_TYPE_REQUEST = 'CREATE_IDENTITY_TYPE_REQUEST'
export const CREATE_IDENTITY_TYPE_SUCCESS = 'CREATE_IDENTITY_TYPE_SUCCESS'
export const CREATE_IDENTITY_TYPE_FAIL = 'CREATE_IDENTITY_TYPE_FAIL'

export const DETAIL_IDENTITY_TYPE_REQUEST = 'DETAIL_IDENTITY_TYPE_REQUEST'
export const DETAIL_IDENTITY_TYPE_SUCCESS = 'DETAIL_IDENTITY_TYPE_SUCCESS'
export const DETAIL_IDENTITY_TYPE_FAIL = 'DETAIL_IDENTITY_TYPE_FAIL'

export const UPDATE_IDENTITY_TYPE_REQUEST = 'UPDATE_IDENTITY_TYPE_REQUEST'
export const UPDATE_IDENTITY_TYPE_SUCCESS = 'UPDATE_IDENTITY_TYPE_SUCCESS'
export const UPDATE_IDENTITY_TYPE_FAIL = 'UPDATE_IDENTITY_TYPE_FAIL'

export const DELETE_IDENTITY_TYPE_REQUEST = 'DELETE_IDENTITY_TYPE_REQUEST'
export const DELETE_IDENTITY_TYPE_SUCCESS = 'DELETE_IDENTITY_TYPE_SUCCESS'
export const DELETE_IDENTITY_TYPE_FAIL = 'DELETE_IDENTITY_TYPE_FAIL'

